import React, { useState } from "react";
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Tooltip, Paper, Card } from "@mui/material";
import RadioButton from "../../components/RadioButton";
import "../../css/OutPutDirectory.css"; // Import the CSS file
import { useSelector } from "react-redux";
import { FORM_KEYS } from "../../utills/constant";
import { motion } from "framer-motion";

const OutPutDirectory = () => {
  const outputOcrFields = useSelector(
    (state) => state.CreateAgentSlice.outputOcrFields
  );

  console.log('outputOcrFields',outputOcrFields)

  return (
    <Card sx={{ p: 3, boxShadow: 3, borderRadius: 2, backgroundColor: "#f9f9f9", mt: 10, ml: 10 }}>
      <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2 }}>
        OUTPUT FIELDS
      </Typography>
      <TableContainer component={Paper} sx={{ boxShadow: 2, borderRadius: 2 }}>
        <Table>
          <TableHead>
            <TableRow sx={{ backgroundColor: "#1976d2" }}>
              <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>Field</TableCell>
              <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>Key</TableCell>
              <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>Description</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {outputOcrFields?.map((item, index) => (
              <TableRow key={index} hover>
                <TableCell>
                  <Typography sx={{ fontWeight: "bold" }}>#{index + 1}</Typography>
                </TableCell>
                <TableCell>
                  {item.key}
                </TableCell>
                <TableCell>{item.label}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Card>
  );
};

export default OutPutDirectory;
